import styled from '@emotion/styled';
import { Flex } from 'components';

export const CommentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px 25px;

  &:nth-of-type(even) {
    background-color: #f2f2f2;
  }
`;

export const CommentText = styled.span`
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 5px;
  line-height: 1.2;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 14px;
  font-weight: ${({ strong }) => (strong ? '600' : 'normal')};
`;

export const CommentBody = styled.p`
  margin: 0 0 5px;
  font-family: ${({ theme }) => theme.fonts.secondary};
  line-height: 1.2;
  font-size: 14px;
`;

export const SpinnerWrapper = styled(Flex)`
  margin-top: 20px;
`;
